import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AppRouter } from "./routes/AppRouter";
import { AuthProvider } from './context/auth'
import { useMixPanel } from './hooks/useMixPanel'
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
function App() {
  const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY
  const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
  const { pathname } = useLocation()

  useEffect(() => {
    if (pathname.includes('/product-search')) {
      return
    }
    document.body.className = ''
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [pathname])


// useMixPanel()

  return (
    <AuthProvider>
      <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
        <Elements stripe={stripePromise}>
          <AppRouter />
        </Elements>
    </GoogleReCaptchaProvider>
    </AuthProvider>
  );
}

export default App;
